import { render } from "./DecoresRCPage.vue?vue&type=template&id=de7691da"
import script from "./DecoresRCPage.vue?vue&type=script&lang=js"
export * from "./DecoresRCPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__